import React from 'react'
export const AlertPopupContext = React.createContext(null)